// First component extracted from app.jsx in the decomposition. A leaf
// presentational component: a signed percentage delta, colored green/red,
// with an optional suffix. esbuild's automatic JSX runtime means no explicit
// React import is needed for plain JSX (no hooks used here).
import { deltaColor, fmtDelta } from '../lib/format.js';

export function DeltaText({ value, suffix }) {
  return (
    <span>
      <span style={{ color: deltaColor(value), fontWeight: 600 }}>{fmtDelta(value)}</span>
      {suffix ? ` ${suffix}` : ''}
    </span>
  );
}
